import { useEffect, useRef } from "react";
import { Capacitor } from "@capacitor/core";
import { useAuth } from "@/contexts/auth-context";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { getRuntimeAppVersion } from "@/lib/appVersion";

const NATIVE_PUSH_PROMPT_KEY = `voltyshare:native_push_prompt_attempted:${getRuntimeAppVersion()}`;

const rememberPromptCompleted = () => {
  try {
    localStorage.setItem(NATIVE_PUSH_PROMPT_KEY, "1");
  } catch {
    /* ignore storage errors */
  }
};

const NativePushBootstrap = () => {
  const { user } = useAuth();
  const { state, subscribe, busy } = usePushNotifications(import.meta.env.VITE_VAPID_PUBLIC_KEY);
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform() || !user || busy || attemptedRef.current) return;
    if (state === "unsupported" || state === "denied") return;

    if (state === "granted") {
      attemptedRef.current = true;
      void subscribe().then((ok) => {
        if (ok) {
          rememberPromptCompleted();
        } else {
          attemptedRef.current = false;
        }
      });
      return;
    }

    let alreadyPrompted = false;
    try {
      alreadyPrompted = localStorage.getItem(NATIVE_PUSH_PROMPT_KEY) === "1";
    } catch {
      alreadyPrompted = false;
    }
    if (alreadyPrompted) return;

    attemptedRef.current = true;
    void subscribe().then((ok) => {
      if (ok) {
        rememberPromptCompleted();
      } else {
        attemptedRef.current = false;
      }
    });
  }, [busy, state, subscribe, user]);

  return null;
};

export default NativePushBootstrap;
